import { render, staticRenderFns } from "./ThemeInput.vue?vue&type=template&id=6ddd5a6e"
import script from "./ThemeInput.vue?vue&type=script&lang=js"
export * from "./ThemeInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports